export default __webpack_public_path__ + "static/media/advisory-board-img2.07c7bfdb.jpg";